import React from 'react';

/**
 * Returns a function to handle keyboard events on form elements. When 'Enter' key presses are the next form
 * element is focused or, if the last element is focused already, the callback function is triggered.
 * @param formRefs an array of React ref of form elements
 * @param lastInputReachedFn callback function that is triggered when event handler is called on last form element
 */
export const onPressEnterHandlerFactory: (
	formRefs: React.RefObject<HTMLElement>[],
	lastInputReachedFn?: (event: React.KeyboardEvent) => void
) => (event: React.KeyboardEvent) => void =
	(formRefs, lastInputReachedFn) => (event) => {
		if (event.key !== 'Enter') {
			return;
		}
		event.preventDefault();
		formRefs.forEach((ref, i) => {
			if (ref.current === event.target) {
				if (i < formRefs.length - 1) {
					const nextRef = formRefs[i + 1];
					if (nextRef && nextRef.current) {
						nextRef.current.focus();
					}
				} else if (lastInputReachedFn) {
					lastInputReachedFn(event);
				}
			}
		});
	};

/**
 * Returns a function to handle select events on form <select> elements. When an input is detected, the next
 * form element is focused or, if the last element is focused already, the callback function is triggered.
 * @param formRefs an array of React ref of form elements
 * @param lastInputReachedFn callback function that is triggered when event handler is called on last form element
 */
export const onSelectInputHandlerFactory: (
	formRefs: React.RefObject<HTMLElement>[],
	lastInputReachedFn?: () => void
) => (event: React.ChangeEvent) => void =
	(formRefs, lastInputReachedFn) => (event) => {
		formRefs.forEach((ref, i) => {
			if (ref.current === event.target) {
				if (i < formRefs.length - 1) {
					// FIXME: without the timeout, the selected value is not persisted in the select field
					setTimeout(() => {
						const nextRef = formRefs[i + 1];
						if (nextRef && nextRef.current) {
							nextRef.current.focus();
						}
					}, 20);
				} else if (lastInputReachedFn) {
					lastInputReachedFn();
				}
			}
		});
	};
